import type {
  GestureEventPayload,
  PanGestureHandlerEventPayload,
} from 'react-native-gesture-handler';

export type UseCardGesturesProps = {
  readonly snapPoints: SwipeSnapPoints;
  readonly minSwipeDistance: number;
  readonly maxSwipeDistance: number;
  readonly onSwipeEnd?: () => void;
  readonly callback?: (() => void) | (() => Promise<void>);
};

export type GestureHandlerProps = Readonly<
  GestureEventPayload & PanGestureHandlerEventPayload
>;

export enum SwipeStatus {
  Idle = 'idle',
  Expanding = 'expanding',
  Expanded = 'expanded',
  Busy = 'busy',
}

export type SwipeSnapPointThresholds = {
  readonly min: number;
  readonly max: number;
};

export type SwipeSnapPoint = {
  readonly width: number;
  readonly thresholds: SwipeSnapPointThresholds;
  readonly shouldTriggerCallback?: boolean;
};

export type SwipeSnapPoints = readonly SwipeSnapPoint[];

export type SetNewSwipeDistanceProps = {
  readonly distance: number;
  readonly smooth?: boolean;
  readonly newStatus?: SwipeStatus;
};

export type AnimatedGestureHandlerContext = {
  // eslint-disable-next-line functional/prefer-readonly-type
  offsetX: number;
};
